import * as Blockly from 'blockly';
import 'blockly/javascript';
import { dictRegistry } from './openfoam.blocks.js';
import { incrementalParse } from '../dsl-engine/openfoam.engine.js';
import * as T from '../dsl-engine/openfoam.tokens.js';
import { cstToAst } from './openfoam.cst_to_ast.js';
import { 
  createBlocksFromAst, 
} from './openfoam.astToBlock.js';

// Export the main function for use in other modules
export { convertOpenFoamToBlocks };

/**
 * Get all block types from the toolbox
 * @param {Blockly.Workspace} workspace - Blockly workspace
 * @returns {string[]} Array of block types
 */
function getToolboxBlockTypes(workspace) {
  try {
    const toolbox = workspace.getToolbox();
    if (!toolbox) {
      console.warn('No toolbox found in workspace');
      return Object.keys(Blockly.Blocks);
    }
    
    const categories = toolbox.getToolboxItems();
    const blockTypes = [];
    
    categories.forEach(category => {
      if (category.getContents) {
        const contents = category.getContents();
        if (contents && contents.blocks) {
          contents.blocks.forEach(block => {
            if (block.type) {
              blockTypes.push(block.type);
            }
          });
        }
      }
    });
    
    if (blockTypes.length === 0) {
      console.log('No blocks found in toolbox, using all registered blocks');
      return Object.keys(Blockly.Blocks);
    }
    
    console.log('Found block types in toolbox:', blockTypes);
    return blockTypes;
  } catch (error) {
    console.error('Error getting toolbox block types:', error);
    return Object.keys(Blockly.Blocks);
  }
}

/**
 * Parse OpenFOAM text to AST
 * @param {string} text - OpenFOAM text
 * @returns {Object} AST object
 */
function parseOpenFoam(text) {
  try {
    console.log('Parsing OpenFOAM text to AST');
    console.log('Text:', text);
    const cst = incrementalParse(text);
    if (!cst) {
      console.error('Failed to parse OpenFOAM text');
      return null;
    }
    return cstToAst(cst);
  } catch (error) {
    console.error('Error parsing OpenFOAM text:', error);
    return null;
  }
}

/**
 * Convert OpenFOAM text to Blockly blocks
 * @param {string} text - OpenFOAM text
 * @param {string} dictName - Dictionary name
 * @param {Blockly.Workspace} workspace - Target Blockly workspace
 * @returns {Blockly.Block} The root block
 */
function convertOpenFoamToBlocks(text, dictName, workspace) {
  try {
    console.log(`Converting OpenFOAM text to blocks for dictionary: ${dictName}`);
    
    const ast = parseOpenFoam(text);
    console.log('Parsed AST:', JSON.stringify(ast, null, 2));
    
    const dictModule = dictRegistry.get(dictName);
    const dictPrefix = dictModule?.prefix || dictName;
    
    const prioritizedBlockTypes = {
      dictionary: dictModule && typeof dictModule.getBlocks === 'function' 
        ? dictModule.getBlocks() 
        : [],
      common: dictRegistry.get('common')?.getBlocks() || [],
      all: getToolboxBlockTypes(workspace)
    };
    
    console.log('Prioritized block types:');
    
    return createBlocksFromAst(ast, dictName, workspace);
  } catch (error) {
    console.error('Error converting OpenFOAM to blocks:', error);
    return null;
  }
}
